import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Hero from '../components/Hero/Hero';
import AboutSection from '../components/AboutSection/AboutSection';
import ServiceSection from '../components/ServiceSection/ServiceSection';
import GrowthStory from '../components/GrowthStory/GrowthStory';
import VisionMission from '../components/VisionMission/VisionMission';
import Performance from '../components/Performance/Performance';
import QuotePage from '../components/ContactForm/QuotePage';
const Home = () => {
  const { state } = useLocation();

  useEffect(() => {
    // If we navigated from another page (like Contact) with a target ID
    if (state?.targetId) {
      const element = document.getElementById(state.targetId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [state]);

  return (
    <>
      <div id="home"><Hero /></div>
      <div><AboutSection /></div>
      <div><ServiceSection /></div>
      <div id="network"><GrowthStory /></div>
       <Performance/>
      <VisionMission />
      <QuotePage/>
     
    </>
  );
};

export default Home;